import type { InferGetStaticPropsType, NextPage } from 'next';
import type { getStaticProps } from '../../pages/[type]/[slug]';
import BlogPost from '../modules/BlogPost';
import Footer from '../modules/Footer';
import PageBottomCTA from '../modules/PageBottomCTA';
import PageMeta from './PageMeta';

type Props = InferGetStaticPropsType<typeof getStaticProps>;

export type NewsPostData = Props['newsPostData'] & { navbarData: Props['navbarData'] };

const NewsPostPage: NextPage<Props> = ({ newsPostData, navbarData }: Props) => {
  const ogImgUrl = newsPostData.image && `${newsPostData.image.url}?fm=png&w=1200&h=630&fit=fill`;
  return (
    <div>
      <PageMeta {...newsPostData} imageUrl={ogImgUrl} slug={`/${newsPostData.type}/${newsPostData.slug}`} type="article">
        <meta property="article:published_time" content={newsPostData.date} />
      </PageMeta>
      <BlogPost {...newsPostData} navbarData={navbarData} returnText="Return to News" returnUrl="/news" shareBaseLocation="/news" />
      {newsPostData.bottomCtaModule && <PageBottomCTA {...newsPostData.bottomCtaModule} />}
      <Footer {...navbarData} />
    </div>
  );
};

export default NewsPostPage;
